import { Attachment } from '@/types/types';
import { ApiQueryKey } from '@/configs/apiQueryKey';
import EntityApi, { BaseEntity } from './EntityApi';
import * as THREE from 'three';

export enum MapType {
	BASE = 'BASE',
	ROUGHNESS = 'ROUGHNESS',
	NORMAL = 'NORMAL',
	HEIGHT = 'HEIGHT',
	METALLNESS = 'METALLNESS',
	AO = 'AO',
	LIGHT = 'LIGHT',
}

export enum AssetType {
	MATERIAL = 'MATERIAL',
	MODEL = 'MODEL',
}

export type AssetOptions = Pick<
	THREE.MeshStandardMaterialParameters,
	'metalness' | 'roughness' | 'color'
>;

export interface Asset extends BaseEntity {
	name: string;
	model?: Attachment;
	type: AssetType;
	maps: Record<MapType, Attachment | null>;
	options: AssetOptions;
}

class AssetApi extends EntityApi<Asset> {
	constructor() {
		super(ApiQueryKey.assets);
	}
}

export default new AssetApi();
